const TUTORIAL_IMAGES_BASE = `${import.meta.env.VITE_SUPABASE_URL}/storage/v1/object/public/tutorials`;

export function tutorialImage(path: string) {
  return `${TUTORIAL_IMAGES_BASE}/${path}`;
}
